import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'company-block-card',
  templateUrl: './company-block-card.component.html',
  styleUrls: ['./company-block-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CompanyBlockCardComponent {
  @Input() public title: string;
  @Input() public tag: string;
  @Input() public tagType: 'success' | 'warning' | 'alert' = 'success';
  @Input() public hint: string;
  @Input() public explanationTitle: string;
  @Input() public explanationSubTitle: string;
  @Input() public isShowRequired: boolean;
  @Input() public isShowOptional: boolean;
  @Input() public isMarginTop: boolean;
  @Input() public isFullHeight: boolean;
  @Input() public isMarginBottom: boolean;
  @Input() public isTitleTranslatable: boolean = true;
  @Input() public isTagTranslatable: boolean = true;
}
